import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a30ebfba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip" }
const _hoisted_2 = ["innerHTML"]

import { withDefaults, ref } from 'vue'

interface Props {
  enabled?: boolean
  text: string
  absolute?: boolean
  location?: 'top' | 'bottom'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTooltip',
  props: {
    enabled: { type: Boolean, default: true },
    text: null,
    absolute: { type: Boolean, default: true },
    location: { default: 'top' }
  },
  setup(__props: any) {

const props = __props as { enabled: boolean, text: string, absolute: boolean, location: 'top' | 'bottom' }

/**
 * AppTooltip.
 */



const isVisible = ref(false)

const showTooltip = () => {
  isVisible.value = true
}

const hideTooltip = () => {
  isVisible.value = false
}

const listeners = {
  mouseenter: showTooltip,
  mouseleave: hideTooltip,
  focus: showTooltip,
  blur: hideTooltip,
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "tooltip" }, {
      default: _withCtx(() => [
        (__props.enabled && isVisible.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["tooltip__main", [__props.absolute ? 'absolute' : '', __props.location]]),
              innerHTML: __props.text
            }, null, 10, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default", { listeners: listeners })
  ]))
}
}

})